// extracted by mini-css-extract-plugin
export var agenda = "LandingImageSection-module--agenda--3ea73";
export var contentItem = "LandingImageSection-module--contentItem--0dcfb";
export var image = "LandingImageSection-module--image--e9f9a";
export var note = "LandingImageSection-module--note--0c19e";
export var wrapper = "LandingImageSection-module--wrapper--2a2fd";
export var wrapperImage = "LandingImageSection-module--wrapperImage--88d1f";